import React from 'react';
import { TimelineDispenseMHRIcon } from '../../../Icons';
import ItemWithTooltip from './ItemWithTooltip';

type Props = {
  item: any;
};
const DispenseMhrMedItem = ({ item }: Props) => {
  return (
    <ItemWithTooltip item={item}>
      <div className="mt-2" />
      <TimelineDispenseMHRIcon />
    </ItemWithTooltip>
  );
};

export default DispenseMhrMedItem;
